import React from 'react';

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={`w-full flex flex-col items-center text-left text-white text-sm/[20px] leading-tight px-2 bottom-0 left-0 right-0 bg-blue-footer pt-[40px] pb-[40px] ${className}`}>
      <div className="w-full max-w-[1200px] mb-2 flex gap-4 text-left justify-start font-bold mb-4 underline">
        <a
          href="https://www.valeur.io/privacy"
          className="hover:underline"
          target="_blank"
          rel="noopener noreferrer">
          Privacy
        </a>
        <a
          href="https://www.authentik8.com.au/terms-of-use"
          className="hover:underline"
          target="_blank"
          rel="noopener noreferrer">
          Terms of Use
        </a>
      </div>
      <div className="w-full max-w-[1200px] leading-5">
        <p>
          All care is taken in the preparation of the information and published
          materials on this site. Valeur PTY LTD does not make any
          representations or give any warranties about its accuracy, reliability,
          completeness or suitability for any particular purpose. To the extent
          permissible by law, Valeur PTY LTD will not be liable for any expenses,
          losses, damages (including indirect or consequential damages) or costs
          which might be incurred as a result of the information being inaccurate
          or incomplete in any way and for any reason.&nbsp;<br />
        </p>
        <br />
        <p>
          If you have any concerns regarding the content of the Website, please
          contact Valeur PTY LTD.
        </p>
        <br />
        <p className="font-bold">©{currentYear} by Valeur Pty Ltd.</p>
      </div>
    </footer>
  );
};

export default Footer;

